import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    TextField
  } from '@material-ui/core';
  import Button from "@components/common/button/Button";
  import * as React from 'react';
  
  import TranslateNew from '@translate/TranslateNew';
  const tn: TranslateNew = TranslateNew.getInstance();
  
  interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (value: string) => void;
  }
  
  interface IState {
    updateEmail: string;
  }
  
  class UpdateEmailDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
  
      this.state = {
        updateEmail: "",
      };
    }


    public render() {
      return (
        <Dialog open={this.props.isOpen} onClose={this.props.onClose}>
          <DialogTitle>
            {tn.lang.changeEmail}
          </DialogTitle>
          <DialogContent>
            <FormControl margin="normal" required={true}>
              <TextField
                label={tn.lang.newEmail}
                variant='outlined'
                type="email"
                id="newEmail"
                name="newEmail"
                onChange={this.handleChange}
                value={this.state.updateEmail.trim()}
              />
            </FormControl>
          </DialogContent>
           <DialogActions>
           <Button onClick={this.props.onClose}>{tn.lang.cancel}</Button>
            <Button
                onClick={() => {
                    if (tn.testEmailIsValid(this.state.updateEmail)) {
                    this.props.onSubmit(this.state.updateEmail);
                    }
                }}
                disabled={!tn.testEmailIsValid(this.state.updateEmail)}
                variant="contained"
                color="primary"
                >
                {tn.testEmailIsValid(this.state.updateEmail) ? tn.lang.update : tn.lang.validationEmailNotValid}
                </Button>
            </DialogActions>
        </Dialog>
      );
    }

    private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const email = e.target.value;
        this.setState({ updateEmail: email});
      };
  }
  
  export default UpdateEmailDialog;
  


// WEBPACK FOOTER //
// ./src/components/settings/update-email.component.tsx